/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import "./CVPaniers.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { InputText } from "primereact/inputtext";
import Header from "Components/Header/Header";
import ButtonsBarDisconnected from "Components/Header/ButtonsBarDisconnected/ButtonsBarDisconnected";
import BtnBlancLeft from "Components/Boutons/BtnBlancLeft/btn-blanc-left";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import Modal from "Components/Modal/Modal";
import NavBarTab from "Components/NavBar/NavBarTab/NavBarTab";
import ChargementImage from "Components/ChargementImage/ChargementImage";
import "primeicons/primeicons.css";
import { HiSearch } from "react-icons/hi";
import { FaPen } from "react-icons/fa";
import { Toast } from "primereact/toast";
import { updatePagination } from "Redux/Actions/paginationActions";
import Pagination from "Components/Pagination/Pagination";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { useFetchGet } from "Services/api";
import CVPanier from "./CVPanier/CVPanier";
import { updateCVs } from "Redux/Actions/cvsActions";
import { classNames } from "primereact/utils";
import Loader from "Components/Loader/loader";

const CVPaniers = (props) => {
  const [visibleModalPanier, setVisibleModalPanier] = useState(false);

  const [image, setImage] = useState(null); //"logo_assas.webp"
  const [imageFile, setImageFile] = useState(null);
  const [imageId, setImageId] = useState(null);
  const uploadToast = useRef(null);
  const cancelToast = useRef(null);
  const [phototheque, setPhototheque] = useState(true);
  const [searchBasket, setSearchBasket] = useState("");

  const panierRef = useRef(null);

  const basketList = useFetchGet("/basket_resumes", props.auth.token);

  useEffect(() => {
    //? Remise à zéro des informations de paginations pour ne pas interférer les affichages des autres pages
    return () => {
      props.handleUpdatePagination({ currentPage: 1 });
      props.handleUpdatePagination({ paginationBasicFirst: 0 });
      props.handleUpdatePagination({ paginationBasicRows: 12 });
    };
  }, []);

  // Chargement de la liste de panier dans redux
  useEffect(() => {
    props.handleUpdateCVs({
      cvsBasket: basketList.data,
    });
  }, [basketList.loaded]);

  // Valeurs par défaut dans le form
  const defaultValues = {
    title: "",
    image: null,
  };

  // variables du formulaire
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    getValues,
  } = useForm({
    defaultValues,
  });

  // Création d'un panier de CV
  const postBasket = (data) => {
    // URL de la requête POST
    let url = `${process.env.REACT_APP_BASE_URL_API}/basket_resumes/create`;
    // On crée un FormData qui sera envoyé au serveur
    let formData = new FormData();
    // On ajoute les données du formulaire au formData
    for (let key in data) formData.append(key, data[key]);
    axios
      .post(url, formData, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then((res) => {
        props.handleUpdateCVs({
          cvsBasket: props.cvs.cvsBasket.concat(res.data),
        });
        // Message de succès
        uploadToast.current.show({
          severity: "success",
          summary: "Succès : ",
          detail: "Le panier a bien été créé",
          life: 3000,
        });
      })
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      })
      .finally(() => {
        reset();
      });
  };

  // Fonction de soumission du formulaire
  const onSubmit = () => {
    // Ferme la fenêtre de création
    setVisibleModalPanier(!visibleModalPanier);
    // Appel la fonction d'ajout dans la base
    var data = getValues();
    data = fillImage(data);
    setImage("");
    setImageFile("");
    setImageId("");
    setPhototheque(true);
    postBasket(data);
  };
  const fillImage = (data) => {
    // Si une image a été téléchargée, on met son url local dans la key imageFile
    if (imageFile && !phototheque) {
      data.imageFile = imageFile;
      delete data.imageStockId;
    }
    // Sinon, on met l'url de l'image choisie de la photothèque
    else if (phototheque) {
      data.imageStockId = imageId;
      delete data.imageFile;
      delete data.image;
    }
    return data;
  };

  // Fonction de recherche
  const handleSearch = (search) => {
    if (search === "") {
      props.handleUpdateCVs({
        cvsBasketIsSearched: false,
      });
    } else {
      props.handleUpdateCVs({
        cvsBasketIsSearched: true,
        cvsBasketFiltered: props.cvs.cvsBasket.filter(
          (basket) => basket.title.toLowerCase().indexOf(search) !== -1
        ),
      });
    }
  };

  // Fonction de gestion des messages d'erreur du form
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  // Fonction de suppression d'un panier, appelée depuis Panier.js
  const deleteBasket = (id) => {
    // URL de la requête POST

    let url = `${process.env.REACT_APP_BASE_URL_API}/basket_resumes/${id}`;
    axios
      .delete(url, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then(() => {
        props.handleUpdateCVs({
          cvsBasket: props.cvs.cvsBasket.filter((basket) => basket.id !== id),
        });

        cancelToast.current.show({
          severity: "error",
          summary: "Suppression : ",
          detail: "Le panier a bien été supprimé",
          life: 800,
        });
      })
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };

  return (
    <div>
      <div className="CVs__container">
        <Toast ref={uploadToast} />
        <Toast ref={cancelToast} />
        <div className="CVs__container__titlePanier">
          <h1 className="h1_trait_dessus CVs__container__titlePanier__title">
            {props.items[props.activeIndex].label}
          </h1>
          <div className="CVs__container__titlePanier__searchAndCreate">
            <div className="cv_paniers_searchBar">
              <HiSearch className="cv_paniers_searchBar__icon" />
              <InputText
                value={searchBasket}
                placeholder="Rechercher un panier..."
                onChange={(e) => {
                  handleSearch(e.target.value.toLowerCase());
                  setSearchBasket(e.target.value.toLowerCase());
                }}
                className="search_paniers"
              />
            </div>
            <BtnBlancLeft
              btnTexte="Créer un panier"
              btnAction={() => setVisibleModalPanier(!visibleModalPanier)}
            >
              <FaPen />
            </BtnBlancLeft>
          </div>
        </div>
        <div className="CVs__container__bouton">
          {!props.auth.isAdmin && props.auth.isConnected && (
            <p>Des CVs sélectionnés rien que pour vous</p>
          )}

          {visibleModalPanier && (
            <Modal
              visible={visibleModalPanier}
              setVisible={setVisibleModalPanier}
              header="Créer un panier de CV"
            >
              <form onSubmit={handleSubmit(onSubmit)}>
                <label
                  htmlFor="title"
                  className={classNames({ "p-error": errors.title })}
                >
                  Titre du panier
                </label>
                <Controller
                  name="title"
                  control={control}
                  rules={{
                    required: "Le titre est requis",
                    minLength: {
                      message: "Le titre doit faire plus de 3 caractères",
                      value: 4,
                    },
                  }}
                  render={({ field, fieldState }) => (
                    <InputText
                      id={field.name}
                      {...field}
                      placeholder="Stage de fin d'études..."
                      className={classNames({
                        "p-invalid": fieldState.invalid,
                      })}
                    />
                  )}
                />
                {getFormErrorMessage("title")}
                <Controller
                  name="image"
                  control={control}
                  render={({ field }) => (
                    <ChargementImage
                      id={field.name}
                      image={image}
                      setImage={setImage}
                      imageFile={imageFile}
                      setImageFile={setImageFile}
                      setImageId={setImageId}
                      uploadToast={uploadToast}
                      cancelToast={cancelToast}
                      phototheque={phototheque}
                      setPhototheque={setPhototheque}
                      path="basket_resumes"
                    />
                  )}
                />
                <div className="boutons_modal">
                  <BtnBlanc btnTexte="Créer" />
                  <BtnBlanc
                    btnTexte="Annuler"
                    btnAction={() => {
                      setVisibleModalPanier(!visibleModalPanier);
                      reset({
                        title: "",
                        image: null,
                      });
                      setImage("");
                      setImageFile("");
                      setImageId("");
                      setPhototheque(true);
                    }}
                  />
                </div>
              </form>
            </Modal>
          )}
        </div>
        <div className="CVs__container__paniers">
          {props.cvs.cvsBasketIsSearched ? (
            props.cvs.cvsBasketFiltered !== null &&
            props.cvs.cvsBasketFiltered
              .slice(
                props.pagination.paginationBasicFirst,
                props.pagination.paginationBasicRows *
                  props.pagination.currentPage
              )
              .map((basket, index) => (
                <CVPanier
                  basketName={basket.title}
                  basketImage={basket.imageUrl}
                  key={index}
                  basketId={basket.id}
                  onDelete={() => {
                    deleteBasket(basket.id);
                  }}
                  cancelToast={cancelToast}
                ></CVPanier>
              ))
          ) : props.cvs.cvsBasket !== null ? (
            props.cvs.cvsBasket
              .slice(
                props.pagination.paginationBasicFirst,
                props.pagination.paginationBasicRows *
                  props.pagination.currentPage
              )
              .map((basket, index) => (
                <CVPanier
                  basketName={basket.title}
                  basketImage={basket.imageUrl}
                  key={index}
                  basketId={basket.id}
                  onDelete={() => {
                    deleteBasket(basket.id);
                  }}
                  cancelToast={cancelToast}
                ></CVPanier>
              ))
          ) : (
            <Loader></Loader>
          )}
        </div>

        <Pagination
          refItemParent={panierRef}
          data={
            props.cvs.cvsBasketIsSearched
              ? props.cvs.cvsBasketFiltered
              : props.cvs.cvsBasket
          }
        />
      </div>
    </div>
  );
};

CVPaniers.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  pagination: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
  cvs: PropTypes.object,
  handleUpdateCVs: PropTypes.func,
  setVisible: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  pagination: state.pagination,
  cvs: state.cvs,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdatePagination: (value) => {
    dispatch(updatePagination(value));
  },
  handleUpdateCVs: (value) => {
    dispatch(updateCVs(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CVPaniers);
